import React, { useEffect, useState } from "react";
import AboutUsSectionImg from "../assets/images/SchoolFront.jpg";
import Accordion from "react-bootstrap/Accordion";
import LoadingOverlay from "./loader/LoadingOverlay";

function About() {
  const [headerLoading, setHeaderLoading] = useState(true);
  const [aboutImgLoading, setAboutImgLoading] = useState(true);

  useEffect(() => {
    const img = new Image();
    img.src = require("../assets/images/AboutUs1.JPG"); // or import path
    img.onload = () => setHeaderLoading(false);
    img.onerror = () => setHeaderLoading(false);
  }, []);

  useEffect(() => {
    const aboutImg = new Image();
    aboutImg.src = AboutUsSectionImg;
    aboutImg.onload = () => setAboutImgLoading(false);
    aboutImg.onerror = () => setAboutImgLoading(false);
  }, []);

  return (
    <div style={{ overflowX: "hidden" }}>
      <div className="about-page">
        {/* HEADER */}
        <header className="position-relative ">
          {headerLoading && (
            <div
              style={{
                position: "absolute",
                inset: 0,
                backgroundColor: "rgba(255, 255, 255, 0.2)",
                zIndex: 10,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <LoadingOverlay overlayOnly />
            </div>
          )}
          <div className="container h-100 d-flex flex-column align-items-center justify-content-center text-light pt-5">
            <h1 className="text-center fw-semibold display-3">About Us</h1>
            <p className="text-center w-75 mb-5 fs-4">
              We provide a balanced education focused on academic excellence,
              personal growth, and life skills, nurturing every student to
              explore their potential and become responsible, well-rounded
              individuals.
            </p>
          </div>
        </header>
      
        {/* About Section */}
        <div className="container my-5 about-container">
          <div className="row align-items-center">
            <div className="col-lg-5 d-flex justify-content-end mb-4 mb-lg-0 pe-lg-7 ms-5">
              {aboutImgLoading ? (
                <div
                  className="d-flex justify-content-center align-items-center w-100"
                  style={{ height: "350px" }}
                >
                  <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>
              ) : (
                <img
                  src={AboutUsSectionImg}
                  className="img-fluid"
                  alt="Front view of Kanchan Vidya Mandir School campus"
                  style={{
                    maxWidth: "125%",
                    height: "100%",
                    width: "550px",
                    marginTop: "-2px",
                  }}
                />
              )}
            </div>

            <div className="col-lg-6 d-flex flex-column justify-content-center">
              <h2 className="mb-3 fs-1">What We Stand For</h2>
              <div className="d-flex flex-column gap-0 fs-5">
                <p>
                  <strong>Kanchan Vidya Mandir Sr. Sec. School</strong> believes
                  education should empower students to lead with knowledge,
                  integrity, and compassion.
                </p>
                <p>
                  We foster a space where curiosity thrives, creativity is
                  valued, and every child feels supported and inspired.
                </p>
                <p>
                  <strong>Our Purpose:</strong> To shape thoughtful, resilient
                  leaders ready to impact the world with purpose.
                </p>
                <p>
                  <strong>Our Values:</strong> Every child is unique and capable
                  of excellence when nurtured with the right values and care.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* FAQ Section */}
        <div id="faq" className="faq-section bg-dark text-light py-5">
          <div
            className="container d-flex flex-column align-items-center px-3 px-md-5"
            style={{ fontSize: "25px" }}
          >
            <h1 className="text-center text-capitalize mb-5">
              Frequently Asked Questions
            </h1>
            <p className="text-center mb-5 fs-4">
              We know that selecting the right school for your child is an
              important decision. Below are answers to some of the most common
              questions about life at Kanchan Vidya Mandir Sr. Sec. School. If
              your query isn’t covered here, feel free to get in touch with us
              directly — we’ll be happy to assist!
            </p>

            <Accordion defaultActiveKey="" alwaysOpen flush>
              <Accordion.Item eventKey="0">
                <Accordion.Header>
                  1. What classes does the school offer?
                </Accordion.Header>
                <Accordion.Body>
                  We currently offer classes from Nursery to Grade 12. Each
                  class is equipped with age-appropriate resources and guided by
                  experienced educators to ensure holistic development.
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="1">
                <Accordion.Header>
                  2. How can I apply for admission?
                </Accordion.Header>
                <Accordion.Body>
                  You can apply by visiting our school office or filling out the
                  application form available online. Once submitted, our
                  admission coordinator will contact you with the next steps,
                  including a brief orientation session.
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="2">
                <Accordion.Header>
                  3. What co-curricular activities are available?
                </Accordion.Header>
                <Accordion.Body>
                  We offer a wide range of activities such as sports, music,
                  dance, art & craft, yoga, and debate. Our goal is to help
                  students discover their interests and develop their talents
                  outside the classroom.
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="3">
                <Accordion.Header>
                  4. Is there a parent-teacher interaction system?
                </Accordion.Header>
                <Accordion.Body>
                  Yes, we conduct regular Parent-Teacher Meetings (PTMs) to keep
                  parents updated on their child’s progress. We also use SMS
                  alerts and school apps for sharing important updates and
                  academic information.
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="4">
                <Accordion.Header>
                  5. What safety measures are in place on campus?
                </Accordion.Header>
                <Accordion.Body>
                  Our campus is secured with CCTV surveillance, trained security
                  staff, and a well-defined emergency response plan. We
                  prioritize student safety and ensure a secure environment
                  throughout the school day.
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </div>
        </div>
      </div>
    </div>
  );
}

export default About;
